var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cgqBox"},[_c('div',{staticClass:"cgqBoxTil"},[_vm._v("\n\t\t\t百万像素·聚焦高画质视界\n\t\t")]),_c('div',{staticClass:"cgqBoxCen"},[_vm._v("\n\t\t\t百万级高像素图像传感器，呈现高分辨率的内镜图像\n\t\t")]),_c('div',{staticClass:"cgqBoxSp"},[_c('img',{attrs:{"src":require("@/assets/product/page6/sp.png")}})])])])
}]

export { render, staticRenderFns }